import { render, staticRenderFns } from "./QuestionBanks.html?vue&type=template&id=4cecced2&external"
import script from "./QuestionBanks.js?vue&type=script&lang=js&external"
export * from "./QuestionBanks.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports